import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { withUser } from 'components/queries/GetUserQuery';

import BookingFeesContainer from './BookingFeesContainer';

export default withRouter(injectIntl(withUser(BookingFeesContainer)));
